<template>
    <div class="w-full h-full flex flex-col">
        <h1 class="text-brand text-lg font-extrabold mb-2 border-gray-200 border-b h-8 overflow-hidden">
            <span class="ml-4 whitespace-nowrap"><i class="fas fa-receipt mr-4"></i>Latest Progress Report</span>
        </h1>
        <main class="overflow-hidden flex-1 place-content-center">
            <div v-if="package && package.progress_report" class="flex flex-col text-gray-500">
                <div class="w-full text-center"><span
                    class="font-semibold">{{ package.progress_report.formatted_date }}</span> by <span
                    class="font-semibold text-brand">{{ package.progress_report.created_by }}</span></div>
                <div class="w-full text-center "><span class="font-semibold">{{ package.progress_report.percentages.total }}%</span> Complete</div>
                <div class="w-full text-center text-sm text-gray-400">(Value:
                    £{{ money(package.progress_report.complete.total) }})
                </div>
            </div>
        </main>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        dashboardData: Object,
        dashboardProps: Object,
    },
    data() {
        return {
            package: null,
        }
    },
    computed: {},
    methods: {
        money: function (val) {
            return parseFloat(val).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        getUrl() {
        },
    },
    mounted() {
        this.package = this.dashboardProps.legacyPackage
    }
}

</script>